import React from 'react';
import { Grid, GridColumn, Typography, Box } from '@kohler-dsm-library/kohler-core';
import styles from '../productFeatureCarousel.module.css';

import AccordionGroup from './AccordionGroup';
import SwatchGroup from './SwatchGroup';
import ProductCategories from './ProductCategories';

export default function ProductInfo({
  productTitle,
  productDetails,
  swatchImages = [],
  categories = [],
  colorHeadline,
  colorFinish,
  additionalText,
  accordionItems = [],
}) {
  return (
    <Grid>
      <GridColumn span={5} spanSmall={6}>
        {productTitle && (
          <Typography size="h5" className={styles.headerTitle}>
            {productTitle}
          </Typography>
        )}
        {productDetails && (
          <Box
            className={styles.productDetails}
            dangerouslySetInnerHTML={{ __html: productDetails }}
          />
        )}
        {accordionItems?.length > 0 && <AccordionGroup items={accordionItems} />}
      </GridColumn>

      <GridColumn span={7} spanSmall={6} className={styles.pfcOptionBlock}>
        <Box>
          {colorHeadline && (
            <Typography size="h5" className={styles.optionsHeadline}>
              {colorHeadline}
            </Typography>
          )}

          <Box className={styles.colorFinishBlock}>
            {colorFinish && (
              <Typography size="label-medium-l" className={styles.colorFinishLabel}>
                {colorFinish}
              </Typography>
            )}

            <SwatchGroup swatches={swatchImages} />

            {additionalText && (
              <Typography size="paragraph-small" className={styles.additionalText}>
                {additionalText}
              </Typography>
            )}
          </Box>
        </Box>
        {categories?.length > 0 && <ProductCategories categories={categories} />}
      </GridColumn>
    </Grid>
  );
}
